export const tagOptions = [
  { value: 'in_process', label: 'En trámite' },
  { value: 'presale', label: 'Preventa' },
  { value: 'sale', label: 'Venta' }
];